<div class="settings-dialog">
  <div class="settings-header">
    <div class="settings-title">
      <fa-icon [icon]="faGear"></fa-icon>
      <span>Preferencias</span>
    </div>
    <button class="btn-close-settings" (click)="close()">
      <i class="fal fa-times"></i>
    </button>
  </div>

  <div class="settings-section">
    <p class="section-label">Estado inicial del carrito</p>
    <div class="sort-options">
      <div class="sort-option"
        [class.selected]="!cartDefaultCollapsed"
        (click)="selectCartDefault(false)">
        <div class="sort-option-radio">
          <div class="radio-inner" *ngIf="!cartDefaultCollapsed"></div>
        </div>
        <div class="sort-option-text">
          <span class="sort-option-label">Extendido</span>
          <span class="sort-option-desc">El carrito aparece visible al entrar</span>
        </div>
      </div>
      <div class="sort-option"
        [class.selected]="cartDefaultCollapsed"
        (click)="selectCartDefault(true)">
        <div class="sort-option-radio">
          <div class="radio-inner" *ngIf="cartDefaultCollapsed"></div>
        </div>
        <div class="sort-option-text">
          <span class="sort-option-label">Colapsado</span>
          <span class="sort-option-desc">El carrito aparece oculto al entrar</span>
        </div>
      </div>
    </div>
  </div>

  <div class="settings-section">
    <p class="section-label">Ordenación del carrito</p>
    <div class="sort-options">
      <div class="sort-option"
        *ngFor="let opt of sortOptions"
        [class.selected]="sortPreference === opt.value"
        (click)="selectSort(opt.value)">
        <div class="sort-option-radio">
          <div class="radio-inner" *ngIf="sortPreference === opt.value"></div>
        </div>
        <div class="sort-option-text">
          <span class="sort-option-label">{{ opt.label }}</span>
          <span class="sort-option-desc">{{ opt.description }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="settings-section" *ngFor="let section of paymentSections">
    <p class="section-label">{{ section.label }}</p>
    <div class="sort-options">
      <div class="sort-option"
        *ngFor="let opt of section.options"
        [class.selected]="directPayment[section.method] === opt.direct"
        (click)="selectDirectPayment(section.method, opt.direct)">
        <div class="sort-option-radio">
          <div class="radio-inner" *ngIf="directPayment[section.method] === opt.direct"></div>
        </div>
        <div class="sort-option-text">
          <span class="sort-option-label">{{ opt.label }}</span>
          <span class="sort-option-desc">{{ opt.description }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
